import React, { useState } from 'react';
import { Drawer, IconButton, Stack, Tab, Tabs, Typography } from '@mui/material';

import { Menu } from '@mui/icons-material';
import { SubTabBarProps } from '.';

export const MobileSubTabBar = <
  T extends {
    id: string;
    label: string;
  },
>({
  tabs,
  selectedTab,
  setSelectedTab,
  ariaLabel,
}: SubTabBarProps<T>) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Stack direction="row" spacing={2} alignItems="center">
        <IconButton
          aria-label="menu"
          onClick={() => setOpen(true)}
          sx={{
            backgroundColor: 'grey.100',
            borderRadius: '4px',
            px: 1,
          }}
        >
          <Menu />
        </IconButton>
        <Typography component="h3" fontWeight="semibold" variant="xl">
          {tabs[selectedTab].label}
        </Typography>
      </Stack>
      <Drawer anchor="left" open={open} onClose={() => setOpen(false)}>
        <Tabs
          orientation="vertical"
          value={selectedTab}
          onChange={(_e, newTab) => {
            setSelectedTab(newTab, tabs[newTab]);
            setOpen(false);
          }}
          aria-label={ariaLabel}
          sx={{
            py: 4,
            pl: 2,
            minWidth: '200px',
            '.MuiTabs-indicator': {
              left: 0,
              width: '4px',
              backgroundColor: 'black',
            },
          }}
        >
          {tabs.map((tab, index) => (
            <Tab
              key={tab.id}
              label={tab.label}
              value={index}
              disableRipple
              sx={{
                textTransform: 'initial',
                fontSize: 14,
                alignItems: 'flex-start',
                color: 'black',

                fontWeight: 400,
                py: 0.5,
                minHeight: '20px',
                mb: 4,
                '&.Mui-selected': {
                  color: 'black',
                  fontWeight: 600,
                },
              }}
            />
          ))}
        </Tabs>
      </Drawer>
    </>
  );
};
